// src/actions/authActions.js

import { axiosInstance as publicAxiosInstance} from "../axios/publicAxios"
import { axiosInstance as privateAxiosInstance} from "../axios/privateAxios"
import {
    SET_AUTH_LOADING,
    SET_AUTH, SET_USER,
    AUTH_FAIL,
    AUTH_SUCCESS,
    UPDATE_FAIL,
    LOGOUT,
    FETCH_ERROR
} from "./authTypes"
import {
    SOCKET_DISCONNECT
} from "./socketTypes"
import { toast } from "react-toastify"


export const login = (data) => async dispatch => {
    dispatch({type: SET_AUTH_LOADING, payload: true})
    try{
        const response = await publicAxiosInstance.post('/users/login',{...data},{ withCredentials: true })
        dispatch({type: SET_AUTH, payload: response.data})
        localStorage.setItem("login-event",new Date())
        return true
    }
    catch(err){
        throw err
    }
    finally{
        dispatch({type: SET_AUTH_LOADING, payload: false})
    }
}

export const signup = (data) => async dispatch => {
    dispatch({type: SET_AUTH_LOADING, payload: true})
    try{
        const response = await publicAxiosInstance.post('/users/register',{...data})
        dispatch({type: SET_AUTH, payload: response.data})
        localStorage.setItem("login-event",new Date())
    }
    catch(err){
        throw err
    }
    finally{
        dispatch({type: SET_AUTH_LOADING, payload: false})
    }    
}

export const logout = () => async dispatch => {
    dispatch({type: SOCKET_DISCONNECT})
    toast.dismiss()
    const toastID = toast.loading(
        <span style = {{ fontSize: "13.5px", fontFamily: 'Poppins, sans-serif'}}>
            Logging out!
        </span>,
        {
            position: "bottom-left"
        }
    )
    try{
        await privateAxiosInstance.post('/users/logout')
    }
    catch(err) {}
    finally{
        toast.dismiss(toastID)
        dispatch({type: LOGOUT})
        localStorage.setItem("logout-event",new Date())
    }  
}

export const forgot_password = (email) => async dispatch => {
    dispatch({type: SET_AUTH_LOADING, payload: true})
    try{
        await publicAxiosInstance.post('/users/forgotPassword',{email})
    }
    catch(err){
        if (err.response?.status !== 400){
            dispatch({type: AUTH_FAIL, payload: true})
        }
        throw err
    }
    finally{
        dispatch({type: SET_AUTH_LOADING, payload: false})
    } 
}

export const verify_code = (email,code) => async dispatch => {
    dispatch({type: SET_AUTH_LOADING, payload: true})
    try{
        await publicAxiosInstance.post('/users/verifyCode',{email,code})
    }
    catch(err){
        if (err.response?.status !== 400 && err.response?.status !== 410){
            dispatch({type: AUTH_FAIL, payload: true})
        }
        throw err
    }
    finally{
        dispatch({type: SET_AUTH_LOADING, payload: false})
    } 
}

export const reset_password = (email,password) => async dispatch => {
    dispatch({type: SET_AUTH_LOADING, payload: true})
    try{
        await publicAxiosInstance.put('/users/resetPassword',{ email, password })
    }
    catch(err){
        if (err.response?.status !== 400){
            dispatch({type: AUTH_FAIL, payload: true})
        }
        throw err
    }
    finally{
        dispatch({type: SET_AUTH_LOADING, payload: false})
    } 
}

export const getProfile = () => async dispatch => {
    try{
        const response = await privateAxiosInstance.get('/users/getProfile')
        dispatch({type: SET_USER, payload: response.data})
    }
    catch(err){
        dispatch({type: FETCH_ERROR, payload: true })
    }
    finally{
    } 
}

export const updateProfile = (data) => async dispatch => {
    dispatch({type: SET_AUTH_LOADING, payload: true})
    try{
        const response = await privateAxiosInstance.put('/users/updateProfile',data)
        dispatch({type: SET_USER, payload: response.data})
    }
    catch(err){
        dispatch({type: UPDATE_FAIL, payload: "update profile"})
    }
    finally{
        dispatch({type: SET_AUTH_LOADING, payload: false})
    }     
}

export const updateEmail = (data) => async dispatch => {
    dispatch({type: SET_AUTH_LOADING, payload: true})
    try{
        const response = await privateAxiosInstance.put('/users/updateEmail',data)
        dispatch({type: SET_USER, payload: response.data})
        dispatch({type: AUTH_SUCCESS, payload: true})
    }
    catch(err){
        if (err.response?.status === 400) throw err 
        dispatch({type: UPDATE_FAIL, payload: "update email"})
    }
    finally{
        dispatch({type: SET_AUTH_LOADING, payload: false})
    }     
}

export const updatePassword = (data) => async dispatch => {
    dispatch({type: SET_AUTH_LOADING, payload: true})
    dispatch({type: AUTH_SUCCESS, payload: false})
    try{
        await privateAxiosInstance.put('/users/updatePassword',data)
        dispatch({type: AUTH_SUCCESS, payload: true})
    }
    catch(err){
        if (err.response?.status === 400) throw err  
        dispatch({type: UPDATE_FAIL, payload: "update password"})
    }
    finally{
        dispatch({type: SET_AUTH_LOADING, payload: false})
    }  
}